/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import FabricCanvasTool from '../fabrictool'

import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'

class Text extends FabricCanvasTool {
  configureCanvas(props) {
    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    canvas.defaultCursor = 'default'
    this._width = props.lineWidth
    this._color = props.lineColor
    this._fill = props.fillColor
  }

  doMouseDown(o) {
    const canvas = this._canvas
    const iText = new fabric.IText('', {
      left: o.pointer.x,
      top: o.pointer.y,
      fill: this._color,
      fontSize: 25
    })

    canvas.add(iText).setActiveObject(iText)
    iText.enterEditing()
    canvas.isDrawingMode = true
  }

  doMouseMove(o) {}

  doMouseUp(o) {}
}

export default Text
